import React from 'react';
import {useSelector} from "react-redux";

const QuickshipDisplay = (props) => {
    const quickshipInt = useSelector(state => state.configuratorStateReducer.quickshipInt);
    const getQuickshipText = () => {
        if (quickshipInt  === 1){
            return "Quickship is available by request"
        } else if (quickshipInt  === 2) {
            return "For Quickship, contact Customer Service"
        } else if (quickshipInt === 0) {
            return "Quickship is unavailable";
        }
        return "";
    }
    return (
        <strong className='quickship' style={{paddingLeft: '15px'}}> { getQuickshipText() }</strong>
    )
}

export default QuickshipDisplay;